/**
 * The route names of the permission UI - the exact strings the views navigate by, so a host
 * that registers the permission routes under other names has to keep these. None of them
 * collides with an `IdentityRoute` name (the route test pins that).
 */
export const PermissionRoute = {
  adminOrganization: "admin-permissions-organization",
  adminGroups: "admin-permissions-groups",
  adminGroup: "admin-permissions-group",
  adminSecurables: "admin-permissions-securables",
  adminHistory: "admin-permissions-history",
  adminRequests: "admin-permissions-requests",
  adminGhosts: "admin-permissions-ghosts",
  myPermissions: "manage-my-permissions",
} as const;

export type PermissionRouteName = (typeof PermissionRoute)[keyof typeof PermissionRoute];
